export const API_BASE_URL = 'https://api.wbehealth.net';


//usato nella seconda versione
export const DATA_ENTRY_URL = API_BASE_URL+'/api/data_entry';